import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { user } from './user';
import { restaurant, isLoadingRestaurant, isSavingRestaurant, isSavedRestaurant, errorRestaurant } from './restaurant';
import { error } from './error';
import { nextReservations } from './nextReservations';
import { errorReserve } from './errorReserve';
import { clearState } from './clearState';
import { places, hitos, cities, countries, neighborhoods, provinces, styles, types, services } from './dataForProfile';
import { promotions, isSavingPromotions, isSavedPromotions } from './promotions';
import { SET_LOGOUT } from './../actions';
import { initialState } from './../store';
import { restaurants } from './restaurants';
import { config, isSavingConfig, isSavedConfig } from './config';
import { servicesAdmin, isSavingServices, isSavedServices } from './servicesAdmin';

const appReducers = combineReducers({
    user,
    restaurant,
    isLoadingRestaurant,
    isSavingRestaurant,
    isSavedRestaurant,
    errorRestaurant,
    error,
    nextReservations,
    errorReserve,
    clearState,
    places,
    hitos,
    cities,
    countries,
    neighborhoods,
    provinces,
    styles,
    types,
    services,
    promotions,
    //admin
    restaurants,
    config,
    isSavingConfig,
    isSavedConfig,
    isSavingPromotions,
    isSavedPromotions,
    servicesAdmin,
    isSavingServices,
    isSavedServices,
});

const rootReducer = (state, action) => {
    if(action.type === SET_LOGOUT) {
        state = initialState;
    }
    return appReducers(state, action);
}

export default rootReducer;

export const getUser = createSelector(state => state.user, user => user);
export const getError = createSelector(state => state.error, error => error);

//Restaurant
export const getRestaurant = createSelector(state => state.restaurant, restaurant => restaurant);
export const getIsLoadingRestaurant = createSelector(state => state.isLoadingRestaurant, isLoadingRestaurant => isLoadingRestaurant);
export const getIsSavingRestaurant = createSelector(state => state.isSavingRestaurant, isSavingRestaurant => isSavingRestaurant);
export const getIsSavedRestaurant = createSelector(state => state.isSavedRestaurant, isSavedRestaurant => isSavedRestaurant);
export const getErrorRestaurant = createSelector(state => state.errorRestaurant, errorRestaurant => errorRestaurant);

//Reservations
export const getErrorReserve = createSelector(state => state.errorReserve, errorReserve => errorReserve);
export const getNextReservations = createSelector(state => state.nextReservations, nextReservations => nextReservations);

//--dataForState--
export const getPromotions = createSelector(state => state.promotions, promotions => promotions);
export const getIsSavingPromotions = createSelector(state => state.isSavingPromotions, isSavingPromotions => isSavingPromotions);
export const getIsSavedPromotions = createSelector(state => state.isSavedPromotions, isSavedPromotions => isSavedPromotions);
//dataForProfile
export const getPlaces = createSelector(state => state.places, places => places);
export const getHitos = createSelector(state => state.hitos, hitos => hitos);
export const getCities = createSelector(state => state.cities, cities => cities);
export const getCountries = createSelector(state => state.countries, countries => countries);
export const getNeighborhoods = createSelector(state => state.neighborhoods, neighborhoods => neighborhoods);
export const getProvinces = createSelector(state => state.provinces, provinces => provinces);
export const getStyles = createSelector(state => state.styles, styles => styles);
export const getTypes = createSelector(state => state.types, types => types);
export const getServices = createSelector(state => state.services, services => services);

//admin
export const getRestaurants = createSelector(state => state.restaurants, restaurants => restaurants);
export const getConfig = createSelector(state => state.config, config => config);
export const getIsSavingConfig = createSelector(state => state.isSavingConfig, isSavingConfig => isSavingConfig);
export const getIsSavedConfig = createSelector(state => state.isSavedConfig, isSavedConfig => isSavedConfig);
export const getServicesAdmin = createSelector(state => state.servicesAdmin, servicesAdmin => servicesAdmin);
export const getIsSavingServices = createSelector(state => state.isSavingServices, isSavingServices => isSavingServices);
export const getIsSavedServices = createSelector(state => state.isSavedServices, isSavedServices => isSavedServices);